import type { TopProduct } from '../../../gateways/breadstack/dashboardApis'
import { htmlDecode } from '../../Category/utils/htmlDecode'

// One-line Top Products label, same rule as pantry order detail
// (gateways/breadstack/orderApis.ts): a variation row reads
// "Parent - Variation"; a simple product, a variation named like its parent,
// or a name already prefixed with the parent shows the name once.
// `parent_name` is optional so an older backend falls back to `name`.

function decodePart(value: string | undefined): string {
  return (htmlDecode((value ?? '').trim()) ?? '').trim()
}

export function formatTopProductName({
  name,
  parent_name,
}: Pick<TopProduct, 'name' | 'parent_name'>): string {
  const decodedName = decodePart(name)
  const parent = decodePart(parent_name)

  if (!parent) return decodedName
  if (!decodedName) return parent
  if (parent === decodedName || decodedName.startsWith(`${parent} - `))
    return decodedName
  return `${parent} - ${decodedName}`
}
